import * as Sentry from '@sentry/react';
import { excludeGraphQLFetch } from 'apollo-link-sentry';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import { App } from './App';
import { loadTrackers } from './support/tracking';

if (import.meta.env.PROD) {
  const isDev = window.location.host === 'play.instruqt.dev';

  Sentry.init({
    dsn: 'https://95926e24757b46c7bab55f8f49f72857@o158370.ingest.sentry.io/1218778',
    release: import.meta.env.VITE_REACT_APP_VERSION,
    environment: isDev ? 'development' : 'production',
    allowUrls: ['instruqt.com', 'instruqt.dev'],
    normalizeDepth: 5,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: isDev ? 1 : 0.1,
    replaysSessionSampleRate: isDev ? 1 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    // https://github.com/DiederikvandenB/apollo-link-sentry#exclude-redundant-fetch-breadcrumbs
    beforeBreadcrumb: excludeGraphQLFetch,
    // ResizeObserver errors are benign, see: https://stackoverflow.com/a/50387233/2106835
    // Object not found matching ID errors are the result of a browser plugin: https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/29
    ignoreErrors: [/^ResizeObserver.*/, /^AbortError.*/, 'Object Not Found Matching Id'],
  });
}

loadTrackers();

// https://docs.sentry.io/platforms/javascript/guides/react/features/component-tracking/
const Profiled = Sentry.withProfiler(App);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<Profiled />);
